// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609242335/js/" + chunkId + "." + {"44":"052eb3b8","225":"90599b12","481":"306139d8","486":"f45edfeb","770":"98f4c014"}[chunkId] + ".0.44757942895606473.chunk.js";
};